// extracted by mini-css-extract-plugin
export default {"color-grey-1":"#707070","colorGrey1":"#707070","color-grey-3":"#DEDDD6","colorGrey3":"#DEDDD6","line":"PuQ25"};